import { api } from "./api";

export const getTestGradings = async (addUrl = '') => {
    let url = `/test/gradings${addUrl}`;
    return await api.get(url);
};

export const testGradingCreate = async (data) => {
    return await api.post(`/test/grading/store`, data);
};

export const testGradingUpdate = async (data) => {
    return await api.post(`/test/grading/update`, data);
};

export const testGradingDelete = async (id) => {
    return await api.post(`/test/grading/delete`, {
        id: id
    });
};

export const testGradingStatusUpdate = async (data) => {
    return await api.post(`/test/grading/status/update`, data);
};